import {API_JSON_KEY} from '../constants'
import moment from 'moment'

export const buildDTNData = (data) => {
  let dtnData = data[API_JSON_KEY.dtn]
  let liveCattle = findLatestDTNObject(dtnData, API_JSON_KEY.dtnLiveCattle)
  let feeder = findLatestDTNObject(dtnData, API_JSON_KEY.dtnFeeder)
  let cdn = findLatestDTNObject(dtnData, API_JSON_KEY.dtnCDN)
  let corn = findLatestDTNObject(dtnData, API_JSON_KEY.dtnCorn)

  return {
    lastUpdated: new Date(
      Math.max.apply(null, [
        liveCattle.lastUpdated,
        feeder.lastUpdated,
        cdn.lastUpdated,
        corn.lastUpdated,
      ]),
    ),
    livecattle: {
      latest: liveCattle.latest,
      feed: relevantDTNFeedObjects(dtnData, API_JSON_KEY.dtnLiveCattle, 6),
      all: relevantDTNFeedObjects(dtnData, API_JSON_KEY.dtnLiveCattle, 100),
    },
    feeder: {
      latest: feeder.latest,
      feed: relevantDTNFeedObjects(dtnData, API_JSON_KEY.dtnFeeder, 8),
      all: relevantDTNFeedObjects(dtnData, API_JSON_KEY.dtnFeeder, 100),
    },
    cdn: {
      latest: cdn.latest,
      feed: relevantDTNFeedObjects(dtnData, API_JSON_KEY.dtnCDN, 6),
      all: relevantDTNFeedObjects(dtnData, API_JSON_KEY.dtnCDN, 100),
    },
    corn: {
      latest: corn.latest,
      feed: relevantDTNFeedObjects(dtnData, API_JSON_KEY.dtnCorn, 6),
      all: relevantDTNFeedObjects(dtnData, API_JSON_KEY.dtnCorn, 100),
    },
  }
}

/**
 * Help parse the DTN Feed data down to something nicer for the application to use.
 *
 * @param {Object} data - Data returned from the DTN Feed
 * @param {String} key - Key in the DTN Feed to look at
 * @returns {Object, Date} latest - The DTN Object in the given key with a year and month closest to today. lastUpdated - The Date of the lastUpdate time of the DTN feed items in that key
 */
export const findLatestDTNObject = (data, key) => {
  let latest = findObjectClosestToToday(data[key])
  return {
    latest: latest,
    lastUpdated: parseApiStringDateToDate(latest.lastUpdated),
  }
}

/**
 * Finds the object in the array of data that is closest to todays year and month.
 * Todays year and month is found with new Date().getFullYear() and (new Data().getMonth() + 1)
 *
 * @param {Array} data - Array of Data. Each object must contain a value for year and month.
 *
 * @returns {Object} - The object whose month and year corresponds to closest to today taking preference to later.
 */
export const findObjectClosestToToday = (data) => {
  return findObjectClosestToDate(data, new Date())
}

/**
 * Finds the object in the array of data that is closest to the given year and month.
 *
 * @param {Array} data - Array of Data. Each object must contain a value for year and month.
 * @param {Date} date - The year to find
 *
 * @returns {Object} - The object whose month and year corresponds to closest to today taking preference to later.
 */
export const findObjectClosestToDate = (data, date) => {
  if (!(date instanceof Date)) {
    date = new Date(date)
  }
  const year = date.getFullYear()
  const month = date.getMonth() + 1

  let latest = null
  let bestRank = Number.MIN_SAFE_INTEGER

  // Find element closest to given date with preference to greater than the given date.
  // Use a ranking system to find the closest and once we go positive always keep that as closest
  // until we find one with a lower ranking to given date.
  // Also track the highest date for the feed retreival last updated.
  data.forEach((element) => {
    if (element == null) {
      return
    }

    let elementRank = (element.year - year) * 12 + (element.month - month)
    if (
      (bestRank > 0 && elementRank < bestRank) ||
      (bestRank < 0 && elementRank > bestRank)
    ) {
      latest = element
      bestRank = elementRank
    }
  })

  return latest
}

export const buildCPIPData = (data) => {
  let cpipData = data[API_JSON_KEY.cpip]
  return {
    lastUpdated: new Date(
      Math.max.apply(
        null,
        cpipData.map((element) => parseApiStringDateToDate(element.date)),
      ),
    ),
    wcpipfed: cpipData.filter(
      (element) => element.feedType === API_JSON_KEY.cpipFed,
    )[0],
    albertafeeder: cpipData.filter(
      (element) => element.feedType === API_JSON_KEY.cpipAlbertaFeeder,
    )[0],
    albertacalf: cpipData.filter(
      (element) => element.feedType === API_JSON_KEY.cpipAlbertaCalf,
    )[0],
    saskmancalf: cpipData.filter(
      (element) => element.feedType === API_JSON_KEY.cpipSaskmanCalf,
    )[0],
    saskmanfeeder: cpipData.filter(
      (element) => element.feedType === API_JSON_KEY.cpipSaskmanFeeder,
    )[0],
  }
}

const relevantDTNFeedObjects = (data, key, count) => {
  let relevantDate = data[key].slice()
  if (relevantDate.length < count) {
    return relevantDate
  }
  return relevantDate.splice(0, count)
}

export const parseApiStringDateToDate = (date) => {
  // return moment(date, 'yyyy-MM-ddHH:mm:ss').utcOffset(-4 * 60).toDate()
  return moment(date, 'YYYY-MM-DDHH:mm:ss').toDate()
}



// WEBPACK FOOTER //
// ./src/helpers/feedParser.js